Bool = Boolean

module.exports = {Bool}
